import type { ApiController } from './api.types'
import axiosController from './axios'
import webviewController from './webview'

const activeController: ApiController = process.env.REACT_APP_API_CONTROLLER === 'WEBVIEW' ? webviewController : axiosController

const api: ApiController = {
  config: () => activeController.config(),
  getProductCategories: () => activeController.getProductCategories(),
  getProducts: categoryId => activeController.getProducts(categoryId),
  getAvailability: request => activeController.getAvailability(request),
  createOrder: payload => activeController.createOrder(payload),
  sendOrderConfirmation: payload => activeController.sendOrderConfirmation(payload)
}

export default api
